import {SocialStreamTab} from '@/types/socialMediaPost';

/**
 * Tooltip copy for the ER column, matching Campaign::Metrics#engagement_rate:
 * reels → plays, follower-based networks → likes+comments/followers,
 * otherwise likes+comments+shares/views. Combined "all" and Stories have
 * no single formula.
 */
export const ENGAGEMENT_RATE_FORMULAS = {
  byFollowers: 'Likes + Comments / Followers',
  byOrganicViews: 'Likes + Comments + Shares / Views (only for organic views)',
  byViews: 'Likes + Comments + Shares / Views',
  byPlays: 'Total Interactions / Unique Plays',
} as const;

const TIKTOK_V2 = 'tiktok_v2';

const VIEWS_BASED_NETWORKS = new Set([
  'tiktok',
  TIKTOK_V2,
  'tiktok_ttcm',
  'tiktok_creator_marketplace',
  'twitter',
  'pinterest_organic',
]);

function isTikTokV2(network?: string | null): boolean {
  return network === TIKTOK_V2;
}

function isViewsBasedNetwork(network?: string | null): boolean {
  if (!network) {
    return false;
  }
  return VIEWS_BASED_NETWORKS.has(network);
}

export function getEngagementRateFormula(
  network?: string | null,
  socialStream?: SocialStreamTab
): string | undefined {
  if (!socialStream || socialStream === 'all' || socialStream === 'story') {
    return undefined;
  }

  if (socialStream === 'reels') {
    return ENGAGEMENT_RATE_FORMULAS.byPlays;
  }

  if (isViewsBasedNetwork(network)) {
    return isTikTokV2(network)
      ? ENGAGEMENT_RATE_FORMULAS.byOrganicViews
      : ENGAGEMENT_RATE_FORMULAS.byViews;
  }

  return ENGAGEMENT_RATE_FORMULAS.byFollowers;
}
